<template>
  <!-- side menu -->
  <div class="cabinet-console-menu" :class="{ 'cabinet-console-menu-collapsed': !expanded }">
    <!-- Logos unidos al menu lateral -->
    <!-- <img :src="imgLogo" class="logo" v-if="expanded"> -->
    <!-- <img src="/assets/images/logo_tradeview_v2.svg" class="collapsed-logo" v-else> -->

    <!-- Collapse arrow and theme switch -->
    <div class="menu-row">
      <button class="collapse-menu" @click="collapseMenu">
        <img src="/assets/images/cabinet_arrow_left.svg" alt />
      </button>
      <!-- switch themes -->
      <CustomSwitch ref="themeSwitch" v-if="expanded" v-model:checked="themeDark"></CustomSwitch>
    </div>

    <!-- Menu Items -->
    <div class="menu" :key="selectedIndex">
      <div class="menu-item" v-for="item in menuItems" :key="item.idx">
        <!-- Item component-->
        <div v-if="region === 'uk'">
          <ConsoleMenuItem v-if="item.show" :idx="item.idx" :activeAccount="activeAccount" :selected="item.selected"
            :icon="item.icon" :iconBlue="item.iconBlue" :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled" :label="item.name" :show-children="item.showChildren"
            :collapsed="!expanded" @clicked="menuItemSelected"></ConsoleMenuItem>
        </div>

        <div v-else-if="region === 'forex'">
          <ConsoleMenuItem v-if="item.show" :idx="item.idx" :activeAccount="activeAccount" :selected="item.selected"
            :icon="item.icon" :iconBlack="item.iconBlack" :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled" :label="item.name" :show-children="item.showChildren"
            :collapsed="!expanded" @clicked="menuItemSelected"></ConsoleMenuItem>
        </div>

        <div v-else-if="region === 'mena'">
          <ConsoleMenuItem v-if="item.show" :idx="item.idx" :activeAccount="activeAccount" :selected="item.selected"
            :icon="item.icon" :iconBlack="item.iconRed" :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled" :label="item.name" :show-children="item.showChildren"
            :collapsed="!expanded" @clicked="menuItemSelected"></ConsoleMenuItem>
        </div>

        <div v-else>
          <ConsoleMenuItem v-if="item.show" :idx="item.idx" :activeAccount="activeAccount" :selected="item.selected"
            :icon="item.icon" :iconPink="item.iconPink" :iconDisabled="item.iconDisabled"
            :optionDisabled="item.optionDisabled" :label="item.name" :show-children="item.showChildren"
            :collapsed="!expanded" @clicked="menuItemSelected"></ConsoleMenuItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

// import menu from "../../menu.js";
// import menuLight from "../../menu-light.js";
import CustomSwitch from "@/components/CustomSwitch";
import ConsoleMenuItem from "@/components/cabinet/ConsoleMenuItem";
import store from "@/store";
import router from "@/router";
import axios from "axios";
import { Logger } from "aws-amplify";
import menu from "@/menu";
import menuLight from "@/menu-light";
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/runtime-core";

const logger = new Logger("main");
export default {
  name: "ConsoleMenu",
  components: {
    CustomSwitch,
    ConsoleMenuItem,
  },
  props: ["expanded"],
  emits: ["expand"],

  setup(props, { emit }) {
    let themeDark = ref();
    let menuItems = ref([]);
    let selectedIndex = ref(0);
    let menuIcons = ref([]);
    const themeSwitch = ref(null);
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    onMounted(() => {
      let userInfo = localStorage.getItem("activeAccount");
      let optionMenu = menu.items;
      let currentUrl = window.location.href;

      let urlSplited = currentUrl.split("/");
      let lastIndex = urlSplited.length - 1;
      let currentTab = urlSplited[lastIndex];

      /*if (userInfo === "ACTIVE" && optionMenu[0].name === "Applications") {
        optionMenu.splice(0, 1);
      }*/
      menuIcons.value = optionMenu;
      menuItems.value = [];
      buildMenu(optionMenu, 0, 0, 0, true);

      const mappedMenuItems = menuItems.value
        .map((item) => {
          if (item.url) {
            let urlSplited = item.url.split("/");
            let lastIndex = urlSplited.length - 1;
            return urlSplited[lastIndex];
          }
          return null;
        })
        .filter((item) => item !== null);

      const selectedMenuItem = mappedMenuItems.find((item) => {
        return currentTab.endsWith(item);
      });

      const selectedIndex = mappedMenuItems.indexOf(selectedMenuItem);

      setTheme();

      emitter.on("preferencesUpdated", () => {
        setTheme();
        if (selectedMenuItem) menuItems.value[selectedIndex].selected = true;
      });
    });

    onUnmounted(() => {
      emitter.off("preferencesUpdated");
    });

    /////////// change of image by theme switch
    const setTheme = () => {
      if (store.state.preferences) {
        let theme = store.state.preferences.theme;
        let htmlElement = document.documentElement;
        menuIcons.value = [];

        switch (theme) {
          case "DARK":
            menuItems.value = [];
            // imgLogo.value = '/assets/images/logo_tradeview_full_dark.svg'
            let userInfo = localStorage.getItem("activeAccount");
            let optionMenu = menuLight.items;
            /*if (userInfo === "ACTIVE" && optionMenu[0].name == "Applications") {
              optionMenu.splice(0, 1);
            }*/
            buildMenu(menuLight.items, 0, 0, 0, true);
            htmlElement.setAttribute("theme", "dark");
            themeDark.value = true;
            break;
          case "LIGHT":
            menuItems.value = [];
            // imgLogo.value = '/assets/images/logo_tradeview_full_light.svg'
            // imgLogo.value = '/assets/images/logo_tradeview_full_dark.svg'
            buildMenu(menu.items, 0, 0, 0, true);
            htmlElement.setAttribute("theme", "light");
            themeDark.value = false;
            break;
          default:
            logger.error("unknown html attribute: ", htmlElement);
            break;
        }
        if (themeSwitch.value) themeSwitch.value.set(themeDark.value);
      }
    };

    const buildMenu = (items, i, k, parent, show) => {
      // console.log(i);
      let userInfo = localStorage.getItem("activeAccount");
      // for (var j in items) {
      //   if (userInfo === 'ACTIVE' && items[0].name === 'Accounts') {
      //     items[j].optionDisabled = false
      //   }
      //   items[0].optionDisabled = false
      //   if (userInfo === 'ACTIVE') {
      //     items[j].optionDisabled = false
      //   } else {
      //     items[j].optionDisabled = true
      //   }
      // }

      let item = items[i];

      item.idx = k;
      item.show = show;
      item.parent = parent;
      item.selected = false;
      if (item.children == null || item.children.length === 0) {
        item.showChildren = null;
      } else {
        item.showChildren = false;
      }
      menuItems.value.push(item);

      if (item.children != null && item.children.length > 0)
        k = buildMenu(item.children, 0, k + 1, k, false);

      if (items.length > i + 1)
        k = buildMenu(items, i + 1, k + 1, parent, show);

      return k;
    };

    const collapseMenu = () => {
      emit("expand");
    };

    //////// element of the selected page
    const menuItemSelected = (idx) => {
      selectedIndex.value = idx;
      if (menuItems.value[idx].showChildren != null) {
        menuItems.value[idx].showChildren = !menuItems.value[idx].showChildren;
        menuItems.value.forEach((item) => {
          if (item.parent === idx) {
            item.show = !item.show;
          } else {
            if (item.parent !== 0) item.show = false;
          }
        });
      } else {
        menuItems.value.forEach((item, i) => {
          item.selected = i === idx;
          item.optionDisabled = false;
        });
        router.push(menuItems.value[idx].url).catch((err) => { });
      }
    };

    watch(themeDark, () => {
      let preferences = store.state.preferences;
      let userInfo = store.state.user;

      preferences.theme = themeDark.value ? "DARK" : "LIGHT";
      emitter.emit("preferencesUpdated");
      if (preferences) {
        preferences.theme = themeDark.value ? "DARK" : "LIGHT";

        if (userInfo !== null && userInfo.registerStatus === "ACTIVE") {
          const _headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + store.state.token,
            'X-Api-Key': process.env.VUE_APP_X_API_KEY
          };
          const _url =
            process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES +
            "/preferences/user";
          const _body = { theme: preferences.theme };

          axios({ method: "post", url: _url, data: _body, headers: _headers })
            .then((result) => {
              // emitter.emit('preferencesUpdated')
            })
            .catch((error) => {
              logger.error(error);
            });
        }
      }
    });

    return {
      collapseMenu,
      menuItemSelected,

      themeSwitch,
      themeDark,
      menuItems,
      selectedIndex,
      // imgLogo,
      menuIcons,
      region,
    };
  },
};
</script>
